<template>
    <div class="container mt-5">
        <div class="row">
            <div class="col-md-8 col-sm-12">
                <h1 v-if="blog != null && blog.title != null">{{ blog.title }}</h1>

                <p>
                    <img :src="`data:image/jpg;base64,${blog.images[0].picture}`" :alt="blog.title" class="img-fluid">
                </p>

                <div v-html="blog.content">

                </div>

            </div>
            <div class="col-md-4 col-sm-12">
                <h2>Top Escort Girls</h2>
                <div class="row">
                    <div class="col-sm-12" v-for="advertisement in topAds" :key="advertisement.id">
                        <div class="m-1 p-1 girl" >
                            <router-link :to="{ name: 'Show', params: {'id': advertisement.id, 'slug': slugify(advertisement.name)}}">
                                <img class="card-img-top" :src="`${cdn_url}/resized/${advertisement.pictures[1].name.replace('.jpg', '.webp')}`" :alt="`${advertisement.name} Escort Girl`">
                            </router-link>
                            <div class="card-body">
                                <h5 class="card-text text-uppercase"><router-link :to="{ name: 'Show', params: {'id': advertisement.id, 'slug': slugify(advertisement.name)}}">{{ advertisement.name }}</router-link></h5>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "BlogShow",
        metaInfo() {
            return {
                title: this.blog.metaTitle,
                meta: [
                    { name: 'description', content: this.blog.metaDescription },
                    {name: 'twitter:card', content: 'summary'},
                    {name: 'twitter:title', content: this.blog.metaTitle},
                    {name: 'twitter:description', content: this.blog.metaDescription},
                    // Facebook OpenGraph
                    {property: 'og:title', content: this.blog.metaTitle},
                    {property: 'og:site_name', content: this.blog.title},
                    {property: 'og:type', content: 'website'},
                    {property: 'og:description', content: this.blog.metaDescription}
                ]
            }
        },
        data() {
            return {
                blog: '',
                topAds: [],
                cdn_url: process.env.VUE_APP_CDN_URL
            }
        },
        created() {
            this.fetchData()
            this.fetchTop()
        },
        methods: {
            fetchData() {
                this.$http.get(`${process.env.VUE_APP_BLOG_API}/news/slug/${this.$route.params.slug}`)
                .then(response => {
                    this.blog = response.data;
                })
            },
            fetchTop() {
                this.$http.get(`${process.env.VUE_APP_API_URL}/advertisements/top`)
                    .then((response) => {
                        this.topAds = response.data;
                    })
            },
            slugify(text)
            {
                return text.toLowerCase().replace(/ /g,'-').replace(/[^\w-]+/g,'');
            }
        }
    }
</script>

<style scoped>

</style>
